<template>
  <el-table class="docutax-request-table" ref="docutaxRequestsTable" stripe :data="filteredRequests" style="width: 100%"
    :default-sort="{ prop: 'createdDate', order: 'descending' }">
    <el-table-column property="officeId" label="Office" width="90" sortable>
      <template slot-scope="{ row }">{{ getEFINForOffice(row.officeId) }}</template>
    </el-table-column>
    <el-table-column property="assignedPreparerName" width="170" label="Preparer" sortable />
    <el-table-column property="clientName" label="Client Name" sortable>
      <template slot-scope="{ row }">
        {{ row.clientName }}
        <br
          v-show="row.clientCellPhone != null && row.clientCellPhone.length && row.clientEmailAddress != null && row.clientEmailAddress.length" />
        <small>{{ row.clientCellPhone }}</small>
        <br
          v-show="row.clientCellPhone != null && row.clientCellPhone.length && row.clientEmailAddress != null && row.clientEmailAddress.length" />
        <small>{{ row.clientEmailAddress }}</small>
        <br />
        <el-link icon="el-icon-s-promotion" type="primary" @click="onSendRequest(row)">Send New Request</el-link>
      </template>
    </el-table-column>
    <el-table-column property="message" label="Message" min-width="120" />
    <el-table-column property="hasResponded" label="Has Responded?" min-width="80">
      <template slot-scope="{ row }">
        {{ row.hasResponded ? 'Yes' : 'No' }}
      </template>
    </el-table-column>
    <el-table-column property="createdDate" label="Created" width="110" sortable>
      <template slot-scope="{ row }">{{ formatDate(row.createdDate) }}</template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'DocutaxRequestsTable',
  props: {
    requests: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    formatDate(date) {
      return moment(date).format('L LT');
    },
    getEFINForOffice(id) {
      return (this.officeMap[id] ? this.officeMap[id].efin : '');
    },
    onSendRequest(row) {
      this.$emit('sendRequest', row);
    },
  },
  computed: {
    ...mapGetters('User', [
      'isManager',
      'user',
    ]),
    ...mapGetters('Lookup', [
      'officeMap',
    ]),
    filteredRequests() {
      return this.requests;
    },
  },
  mounted() {
    this.getOffices();
  },
};

</script>

<style lang="scss" scoped>
.client-header {
  h2 {
    margin: 0;
    padding: 0 5px;
    font-size: 1.8em;

    span {
      font-weight: normal;
      color: #999;
      font-size: 0.75em;
      text-transform: uppercase;
    }
  }
}

.editable-tag {
  cursor: pointer;
}

.documents-column {
  .el-button {
    padding-bottom: 0;
  }

  .el-button:disabled {
    cursor: default;
  }

  .el-button+.el-button {
    margin-left: 0;
  }
}
</style>
